<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'courseEqualization_returnTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="form-field required">
            <label class="form-label">{{'courseEqualization_lblJustification' | translate}}</label>
            <textarea class="form-control"
                      [(ngModel)]="comment"
                      rows="5"
                      name="comment"
                      maxlength="4000"
                      [required]="true"
                      #commentInput="ngModel"
                      autofocus>
            </textarea>
            <div class="invalid-feedback" *ngIf="commentInput.errors?.maxlength">
                {{'fieldError_lengthMinMax' | translate | formatString:[0, 4000]}}
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{'dialog_cancel' | translate}}</button>
    <button class="btn btn-primary" type="button" (click)="ok()" [disabled]="!form.valid">{{'dialog_ok' | translate}}</button>
</div>
